/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { Container, Row, Col } from 'react-grid-system'

import H1 from '../typography/H1'
import H2 from '../typography/H2'
import ImageResponsive from '../images/ImageResponsive'
import P2 from '../typography/P2'
import theme, { mq } from '../../theme'

interface Props {
  img: string
}

const AboutUsSection4: React.FC<Props> = (props) => {
  const { img } = props
  return (
    <div
      css={{
        marginTop: '4em',
        backgroundColor: theme.colors.grayBg1,
      }}
    >
      <Container fluid={true}>
        <Row>
          <Col xs={12} md={6}>
            <div
              css={[
                {
                  maxWidth: '600px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  padding: '4em',
                },
                // mq('', 'minDesktop', { paddingTop: '3em' }),
              ]}
            >
              <H1 css={[mq('mt0')]}>
                Discover and visualise your selections in your space
              </H1>
              <P2>
                Our innovative visualisation tools help you figure out the
                perfect art and design combinations, to scale.
              </P2>
              <P2>
                Easily find that one key statement piece to transform and
                accentuate your space, or mix and match with limitless
                variations.
              </P2>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div
              css={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <ImageResponsive src={img} alt={''} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AboutUsSection4
